const pages = {
  all: '/expenses/create/(.*)?',
  index: '/expenses/create',
  linkBankAccount: '/expenses/create/link-bank-account',
};

export default pages;
